export default "__VITE_ASSET__BzR88RvR__"